export const MODE_CLOSED = 'closed';
export const MODE_OPEN = 'open';
export const MODE_DONE = 'done';

